import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CustomerContainerComponent } from './customer/customer-container.component';
import { CrestronContainerComponent } from './crestron/crestron-container.component';
import { AuthorizationModule } from '../authorization/authorization.module';
@NgModule({
    imports: [
        RouterModule,
        AuthorizationModule
    ],
    exports: [
        CustomerContainerComponent,
        CrestronContainerComponent
    ],
    declarations: [
        CustomerContainerComponent,
        CrestronContainerComponent
    ],
    providers: [
        
    ],
})
export class ContainersModule { }



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/containers/containers.module.ts